<template>
  <div v-if="!isTouchDevice" class="cursor-dot" :style="dotStyle"></div>
  <div v-if="!isTouchDevice" class="cursor-outline" :class="{ hover: isHovering }" :style="outlineStyle"></div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted, computed } from 'vue'

const x = ref(0)
const y = ref(0)
const isHovering = ref(false)
const isTouchDevice = ref(false)

const dotStyle = computed(() => ({ left: x.value + 'px', top: y.value + 'px' }))
const outlineStyle = computed(() => ({ left: x.value + 'px', top: y.value + 'px' }))

const onMouseMove = (e: MouseEvent) => {
  x.value = e.clientX
  y.value = e.clientY
}

const onMouseOver = (e: MouseEvent) => {
  const target = e.target as HTMLElement
  if (target.closest('a, button, .card-elevated, .amount-btn, .method-card, .story-card, .resource-card, .social-card, ion-button, ion-card')) {
    isHovering.value = true
  }
}

const onMouseOut = () => { isHovering.value = false }

onMounted(() => {
  isTouchDevice.value = window.matchMedia('(pointer: coarse)').matches
  if (!isTouchDevice.value) {
    window.addEventListener('mousemove', onMouseMove)
    document.addEventListener('mouseover', onMouseOver)
    document.addEventListener('mouseout', onMouseOut)
  }
})

onUnmounted(() => {
  window.removeEventListener('mousemove', onMouseMove)
  document.removeEventListener('mouseover', onMouseOver)
  document.removeEventListener('mouseout', onMouseOut)
})
</script>

<style scoped>
.cursor-dot, .cursor-outline {
  position: fixed;
  top: 0;
  left: 0;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  z-index: 9999;
  pointer-events: none;
}
.cursor-dot {
  width: 8px;
  height: 8px;
  background: var(--vh-dorado);
}
.cursor-outline {
  width: 40px;
  height: 40px;
  border: 2px solid var(--vh-dorado);
  transition: width 0.2s, height 0.2s, background 0.2s;
}
.cursor-outline.hover {
  width: 60px;
  height: 60px;
  background: rgba(251, 166, 54, 0.1);
  border-color: var(--vh-azul-profundo);
}
</style>
